import React from "react";
import { Step } from "../../pages/CreateProject/types";

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-center mb-12">
      {steps.map((step, index) => (
        <div key={`step-${step.number}`} className="flex items-center">
          <div className="flex flex-col items-center">
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-semibold transition-colors ${
                step.number < currentStep
                  ? "bg-bits-blue text-white"
                  : step.number === currentStep
                  ? "bg-bits-blue text-white"
                  : "bg-gray-200 text-gray-500"
              }`}
            >
              {step.number}
            </div>
            <div className="mt-2 text-center">
              <div className="text-sm font-medium text-gray-900">
                {step.title}
              </div>
              <div className="text-xs text-gray-500">{step.subtitle}</div>
            </div>
          </div>

          {index < steps.length - 1 && (
            <div
              key={`step-divider-${step.number}`}
              className={`w-24 h-0.5 mx-4 -mt-5 ${
                step.number < currentStep ? "bg-bits-blue" : "bg-gray-200"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};
